// @ts-nocheck 5346d242
import * as addPanel from '#packages/oldAddPanel';

export default {
  getCategorySections() {
    return addPanel.sections.getSections().embeds;
  },
};
